var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongXianshi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3C4 3 2.333 6.333 2 8c.333 1.667 2 5 6 5s5.667-3.333 6-5c-.333-1.667-2-5-6-5z",
    stroke: "#3F465C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 2,
    stroke: "#3F465C"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggM0M0IDMgMi4zMzMzMyA2LjMzMzMzIDIgOEMyLjMzMzMzIDkuNjY2NjcgNCAxMyA4IDEzQzEyIDEzIDEzLjY2NjcgOS42NjY2NyAxNCA4QzEzLjY2NjcgNi4zMzMzMyAxMiAzIDggM1oiIHN0cm9rZT0iIzNGNDY1QyIvPgo8Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iMiIgc3Ryb2tlPSIjM0Y0NjVDIi8+Cjwvc3ZnPgo=";
export { SvgTongyongXianshi as ReactComponent };